// extracted by mini-css-extract-plugin
module.exports = {"infoItems":"student-info_infoItems__2ekpC"};